import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ComponentSync, TS_CollapsableContainer } from '@nu-art/thunderstorm-frontend/index';
import { asArray } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { ModuleFE_Pathway } from '../../../../../../../_entity/pathway/index.js';
export class Section_PathwayChildren extends ComponentSync {
    __onPathwayUpdated(...params) {
        if (asArray(params[1]).every(pathway => pathway._id !== this.state.pathwayId))
            return;
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.pathwayId = nextProps.pathwayId;
        state.children = ModuleFE_Pathway.getChildren(state.pathwayId);
        return state;
    }
    render() {
        if (!this.state.children.length)
            return;
        return _jsx(TS_CollapsableContainer, { customCaret: _jsx(ICONS.advisorArrowDown.component, {}), headerRenderer: () => _jsx(_Fragment, { children: "Pathway Children" }), containerRenderer: () => _jsx(_Fragment, { children: this.state.children.map(child => (_jsx("div", { onClick: () => this.props.functions.selectPathway(child._id), className: 'clickable', children: child.label }, child._id))) }) });
    }
}
//# sourceMappingURL=Section_PathwayChildren.js.map